/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductVariantDto } from '../../models/backend-product-variant-dto';
import { BackendProductVariantRequestDto } from '../../models/backend-product-variant-request-dto';

export interface SalesProductVariantsUpdate$FormData$Params {
  /**
   * A unique integer value identifying this product variant.
   */
  id: number;
  body: BackendProductVariantRequestDto;
}

export function salesProductVariantsUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesProductVariantsUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductVariantDto>> {
  const rb = new RequestBuilder(rootUrl, salesProductVariantsUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductVariantDto>;
    }),
  );
}

salesProductVariantsUpdate$FormData.PATH = '/api/sales/product_variants/{id}/';
